import { getCanvasMinHeight, getCanvasWidth, gridDefaultPixelDensity } from 'components/editor/shared/gridConfig';
import { MarginSide } from '../DocumentSettings/DocumentDesignSettings/models/MarginSide.enum';
import { MarginSettingsView } from '../DocumentSettings/DocumentDesignSettings/margin/MarginSettingsView';
import type { SectionStyles } from 'components/editor/Sections/Section.model';

interface Props {
  styles: SectionStyles;
  onUpdate: (newStyles: SectionStyles) => void;
}

const defaultMargin = { top: 0, bottom: 0, left: 0, right: 0 };

export function SectionMarginSettings({ styles, onUpdate }: Props) {
  const margin = styles.margin ?? defaultMargin;
  const canvasWidth = getCanvasWidth(styles.pageOrientation);
  const canvasHeight = getCanvasMinHeight(styles.pageOrientation);

  const handleChange = (value: string | number, position: MarginSide) => {
    const inches = typeof value === 'string' ? parseFloat(value) : value;
    if (inches < 0) return;
    const px = inches * gridDefaultPixelDensity;
    if ((position === MarginSide.LEFT || position === MarginSide.RIGHT) && px > canvasWidth) return;
    if ((position === MarginSide.TOP || position === MarginSide.BOTTOM) && px > canvasHeight) return;
    const newMargin = { ...margin, [MarginSide[position].toLowerCase()]: parseFloat(px.toFixed(2)) };
    onUpdate({ ...styles, margin: newMargin });
  };

  return (
    <MarginSettingsView
      margin={margin}
      canvasWidth={canvasWidth}
      canvasHeight={canvasHeight}
      previewWidth={110}
      previewHeight={140}
      onChange={handleChange}
      idPrefix="section"
    />
  );
}
